import React, { FC, useMemo } from 'react';
import format from 'date-fns/format';
import { DATE_FORMAT } from '../../constants';
import classNames from 'classnames';
import './FormattedDate.scss';

export const FormattedDate: FC<{
  date: Date;
  className?: string;
}> = ({ date, className }) => {
  const value = useMemo(() => format(date, DATE_FORMAT), [date]);

  return <span className={classNames('FormattedDate', className)}>{value}</span>;
};
